import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import RelationPicker from './RelationPicker';
import AudioPlaylistPicker, { MAX_AUDIO_TRACKS } from './AudioPlaylistPicker';
import AartiSchedulePicker from './AartiSchedulePicker';
import { _axios } from '../../utils/axios';

const STREAM_CATEGORIES = [
    { value: 'live_darshan', label: 'Deity Darshan' },
    { value: 'live_podcasts', label: 'Podcast' },
    { value: 'live_discourse', label: 'Discourse' },
    { value: 'live_aarti', label: 'Aarti' },
    { value: 'live_event_coverage', label: 'Event Coverage' },
    { value: 'live_pooja', label: 'Pooja' },
];

// '2026-04-06 10:47:56' or ISO -> 'YYYY-MM-DDTHH:mm' for datetime-local input
const toLocalDatetimeValue = (val) => {
    if (!val) return '';
    return val.replace(' ', 'T').slice(0, 16);
};

// 'YYYY-MM-DDTHH:mm' -> '2026-04-06 10:47:00' for backend
const toDbDatetime = (val) => {
    if (!val) return null;
    return val.replace('T', ' ') + ':00';
};

const SponsorFields = ({ formData, handleInputChange, inputStyle, labelStyle }) => (
    <>
        {/* Sponsor 1 Names */}
        <Row className='mb-3'>
            {[
                { name: 'sponsor_1_name',     placeholder: 'English',   label: 'Sponsor 1 Name',            required: true },
                { name: 'sponsor_1_name_mar', placeholder: 'मराठी',     label: 'Sponsor 1 Name (Marathi)',  required: false },
                { name: 'sponsor_1_name_hin', placeholder: 'हिन्दी',    label: 'Sponsor 1 Name (Hindi)',    required: false },
                { name: 'sponsor_1_name_guj', placeholder: 'ગુજરાતી',  label: 'Sponsor 1 Name (Gujarati)', required: false },
            ].map(f => (
                <Col md={3} key={f.name}>
                    <Form.Group>
                        <Form.Label className='mb-2' style={labelStyle}>
                            {f.label}{f.required && <span className='text-danger'> *</span>}
                        </Form.Label>
                        <Form.Control type='text' name={f.name} value={formData[f.name]}
                            onChange={handleInputChange} placeholder={f.placeholder} style={inputStyle} />
                    </Form.Group>
                </Col>
            ))}
        </Row>

        {/* Sponsor 1 Image */}
        <Row className='mb-3'>
            <Col md={6}>
                <Form.Group>
                    <Form.Label className='mb-2' style={labelStyle}>Sponsor 1 Image URL</Form.Label>
                    <Form.Control type='text' name='sponsor_1_image' value={formData.sponsor_1_image}
                        onChange={handleInputChange} placeholder='https://cdn.example.com/sponsor1.webp' style={inputStyle} />
                </Form.Group>
            </Col>
        </Row>

        {/* Sponsor 1 Info */}
        <Row className='mb-3'>
            {[
                { name: 'sponsor_1_info',     placeholder: 'English',   label: 'Sponsor 1 Info (English)' },
                { name: 'sponsor_1_info_mar', placeholder: 'मराठी',     label: 'Sponsor 1 Info (Marathi)' },
                { name: 'sponsor_1_info_hin', placeholder: 'हिन्दी',    label: 'Sponsor 1 Info (Hindi)' },
                { name: 'sponsor_1_info_guj', placeholder: 'ગુજરાતી',  label: 'Sponsor 1 Info (Gujarati)' },
            ].map(f => (
                <Col md={3} key={f.name}>
                    <Form.Group>
                        <Form.Label className='mb-2' style={labelStyle}>{f.label}</Form.Label>
                        <Form.Control as='textarea' rows={3} name={f.name} value={formData[f.name]}
                            onChange={handleInputChange} placeholder={f.placeholder}
                            style={{ border: '1px solid #E2E8F0', borderRadius: '6px' }} />
                    </Form.Group>
                </Col>
            ))}
        </Row>

        {/* Sponsor 2 Names */}
        <Row className='mb-3'>
            {[
                { name: 'sponsor_2_name',     placeholder: 'English',   label: 'Sponsor 2 Name' },
                { name: 'sponsor_2_name_mar', placeholder: 'मराठी',     label: 'Sponsor 2 Name (Marathi)' },
                { name: 'sponsor_2_name_hin', placeholder: 'हिन्दी',    label: 'Sponsor 2 Name (Hindi)' },
                { name: 'sponsor_2_name_guj', placeholder: 'ગુજરાતી',  label: 'Sponsor 2 Name (Gujarati)' },
            ].map(f => (
                <Col md={3} key={f.name}>
                    <Form.Group>
                        <Form.Label className='mb-2' style={labelStyle}>{f.label}</Form.Label>
                        <Form.Control type='text' name={f.name} value={formData[f.name]}
                            onChange={handleInputChange} placeholder={f.placeholder} style={inputStyle} />
                    </Form.Group>
                </Col>
            ))}
        </Row>

        {/* Sponsor 2 Image */}
        <Row className='mb-3'>
            <Col md={6}>
                <Form.Group>
                    <Form.Label className='mb-2' style={labelStyle}>Sponsor 2 Image URL</Form.Label>
                    <Form.Control type='text' name='sponsor_2_image' value={formData.sponsor_2_image}
                        onChange={handleInputChange} placeholder='https://cdn.example.com/sponsor2.webp' style={inputStyle} />
                </Form.Group>
            </Col>
        </Row>

        {/* Sponsor 2 Info */}
        <Row className='mb-3'>
            {[
                { name: 'sponsor_2_info',     placeholder: 'English',   label: 'Sponsor 2 Info (English)' },
                { name: 'sponsor_2_info_mar', placeholder: 'मराठी',     label: 'Sponsor 2 Info (Marathi)' },
                { name: 'sponsor_2_info_hin', placeholder: 'हिन्दी',    label: 'Sponsor 2 Info (Hindi)' },
                { name: 'sponsor_2_info_guj', placeholder: 'ગુજरாતી',  label: 'Sponsor 2 Info (Gujarati)' },
            ].map(f => (
                <Col md={3} key={f.name}>
                    <Form.Group>
                        <Form.Label className='mb-2' style={labelStyle}>{f.label}</Form.Label>
                        <Form.Control as='textarea' rows={3} name={f.name} value={formData[f.name]}
                            onChange={handleInputChange} placeholder={f.placeholder}
                            style={{ border: '1px solid #E2E8F0', borderRadius: '6px' }} />
                    </Form.Group>
                </Col>
            ))}
        </Row>
    </>
);

const FeaturedRow = ({ formData, setFormData, handleInputChange, inputStyle, labelStyle }) => (
    <>
        {/* <Form.Check type='checkbox' label='Featured Stream' name='is_featured' checked={formData.is_featured} onChange={handleInputChange} /> */}
        <Row className='mb-3' style={{ alignItems: 'flex-end' }}>
            <Col md={3}>
                <Form.Group>
                    <Form.Label className='mb-2' style={labelStyle}>Stream Start</Form.Label>
                    <Form.Control type='datetime-local' name='stream_start_at' value={formData.stream_start_at}
                        onChange={handleInputChange} style={inputStyle} />
                </Form.Group>
            </Col>
            {/* <Col md={3}>
                <Form.Group>
                    <Form.Label className='mb-2' style={labelStyle}>Stream End</Form.Label>
                    <Form.Control type='datetime-local' name='stream_end_at' value={formData.stream_end_at}
                        onChange={handleInputChange} style={inputStyle} />
                </Form.Group>
            </Col> */}
            <Col md={3}>
                <Form.Group>
                    <Form.Label className='mb-2' style={labelStyle}>Max Quality</Form.Label>
                    <Form.Select name='max_quality' value={formData.max_quality} onChange={handleInputChange} style={inputStyle}>
                        {['360p', '480p', '720p', '1080p', '1440p', '4K'].map(q => <option key={q} value={q}>{q}</option>)}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={3} style={{ display: 'flex', alignItems: 'center', paddingBottom: '11px' }}>
                <Form.Check type='checkbox' label='Display Sponsor' name='display_sponsor'
                    checked={formData.display_sponsor} onChange={handleInputChange} style={{ fontSize: '16px' }} />
            </Col>
            <Col md={3} style={{ display: 'flex', alignItems: 'center', paddingBottom: '11px' }}>
                <Form.Check type='checkbox' label='Enable Multi View' name='enable_multi_view'
                    checked={formData.enable_multi_view} onChange={handleInputChange} style={{ fontSize: '16px' }}
                    title='Allows this stream to be selected when creating a Multi View group.' />
            </Col>
        </Row>
    </>
);

const MAX_ANIMATIONS = 5;

const AnimationSection = ({ formData, setFormData, inputStyle, labelStyle }) => {
    const enabled = formData.enable_animation === 1;
    const urls = formData.animation_urls && formData.animation_urls.length ? formData.animation_urls : [''];

    const updateUrl = (idx, value) => {
        setFormData(prev => {
            const next = [...(prev.animation_urls && prev.animation_urls.length ? prev.animation_urls : [''])];
            next[idx] = value;
            return { ...prev, animation_urls: next };
        });
    };

    const removeUrl = (idx) => {
        setFormData(prev => {
            const next = (prev.animation_urls || []).filter((_, i) => i !== idx);
            return { ...prev, animation_urls: next.length ? next : [''] };
        });
    };

    const addUrl = () => {
        setFormData(prev => {
            const cur = prev.animation_urls && prev.animation_urls.length ? prev.animation_urls : [''];
            if (cur.length >= MAX_ANIMATIONS) return prev;
            return { ...prev, animation_urls: [...cur, ''] };
        });
    };

    return (
        <Row className='mb-3'>
            <Col md={12}>
                <div style={{
                    padding: '14px 18px', borderRadius: '10px',
                    border: '1px solid #E2E8F0', background: '#FAFAFA',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: enabled ? '14px' : '0' }}>
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '14px', color: '#4A5568', marginBottom: '3px' }}>
                                Enable Live Stream Animation
                            </div>
                            <div style={{ fontSize: '12px', color: '#718096' }}>
                                Show a short animation before the live stream opens. Add up to {MAX_ANIMATIONS} R2 CDN links.
                            </div>
                        </div>
                        <Form.Check
                            type='switch'
                            id='enable_animation_switch'
                            checked={enabled}
                            onChange={(e) => setFormData(prev => ({
                                ...prev,
                                enable_animation: e.target.checked ? 1 : 0,
                                animation_urls: e.target.checked ? (prev.animation_urls && prev.animation_urls.length ? prev.animation_urls : ['']) : [],
                            }))}
                            style={{ fontSize: '16px' }}
                        />
                    </div>

                    {enabled && (
                        <>
                            <Form.Label className='mb-2' style={{ ...labelStyle, fontSize: '14px' }}>
                                Select Animation <span style={{ fontSize: '12px', color: '#A0AEC0', fontWeight: 400 }}>({urls.filter(u => u.trim()).length}/{MAX_ANIMATIONS})</span>
                            </Form.Label>
                            {urls.map((url, idx) => (
                                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                                    <Form.Control
                                        type='text'
                                        value={url}
                                        onChange={(e) => updateUrl(idx, e.target.value)}
                                        placeholder='https://your-r2-bucket.r2.dev/animations/lotus.mp4'
                                        style={inputStyle}
                                    />
                                    {url.trim() && (
                                        <a href={url} target='_blank' rel='noopener noreferrer'
                                            style={{ fontSize: '13px', color: '#5662F6', fontWeight: '600', whiteSpace: 'nowrap' }}>
                                            Open
                                        </a>
                                    )}
                                    <Button
                                        variant='outline-danger'
                                        size='sm'
                                        onClick={() => removeUrl(idx)}
                                        disabled={urls.length === 1 && !url}
                                        style={{ padding: '4px 10px' }}
                                    >
                                        ×
                                    </Button>
                                </div>
                            ))}
                            <Button
                                variant='outline-primary'
                                size='sm'
                                onClick={addUrl}
                                disabled={urls.length >= MAX_ANIMATIONS}
                                style={{ marginTop: '4px' }}
                            >
                                + Add Animation
                            </Button>
                        </>
                    )}
                </div>
            </Col>
        </Row>
    );
};

const AudioSection = ({
    formData, setFormData,
    audioArtifacts, searchArtifact, setSearchArtifact, onFetchArtifacts, artifactsFetched,
    selectedAudioArtifacts, setSelectedAudioArtifacts,
}) => {
    const isOriginalSound = formData.original_sound === 1;
    return (
        <>
            <hr style={{ margin: '8px 0 16px', borderColor: '#E2E8F0' }} />
            <div style={{ marginBottom: '12px' }}>
                <span style={{ fontWeight: '600', fontSize: '15px', color: '#4A5568' }}>Audio</span>
            </div>
            <Row className='mb-2'>
                <Col md={3} style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Check type='checkbox' label='Original Sound'
                        checked={isOriginalSound}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            setFormData(prev => ({ ...prev, original_sound: checked ? 1 : 0 }));
                            if (checked) setSelectedAudioArtifacts([]);
                        }}
                        style={{ fontSize: '16px' }} />
                </Col>
            </Row>
            {!isOriginalSound && (
                <AudioPlaylistPicker
                    audioArtifacts={audioArtifacts}
                    searchValue={searchArtifact}
                    onSearchChange={setSearchArtifact}
                    onFetchArtifacts={onFetchArtifacts}
                    artifactsFetched={artifactsFetched}
                    selected={selectedAudioArtifacts}
                    onChange={setSelectedAudioArtifacts}
                />
            )}
        </>
    );
};

const CreateLiveStream = ({ show, onHide }) => {
    const [formData, setFormData] = useState({
        stream_type: 'youtube',
        stream_status: 'draft',
        stream_category: 'live_darshan',
        youtube_video_id: '',
        stream_key: '',
        rtsp_url: '',
        hls_url: '',
        stream_start_at: '',
        stream_end_at: '',
        stream_title: '',
        stream_title_mar: '',
        stream_title_hin: '',
        stream_title_guj: '',
        thumbnail_url: '',
        is_featured: false,
        enable_multi_view: false,
        auto_convert: 0,
        stream_mode: 'rtmp_push',
        orientation: 'portrait',
        max_quality: '1080p',
        display_sponsor: false,
        sponsor_1_name: '',
        sponsor_1_name_mar: '',
        sponsor_1_name_hin: '',
        sponsor_1_name_guj: '',
        sponsor_2_name: '',
        sponsor_2_name_mar: '',
        sponsor_2_name_hin: '',
        sponsor_2_name_guj: '',
        sponsor_1_image: '',
        sponsor_1_info: '',
        sponsor_1_info_mar: '',
        sponsor_1_info_hin: '',
        sponsor_1_info_guj: '',
        sponsor_2_image: '',
        sponsor_2_info: '',
        sponsor_2_info_mar: '',
        sponsor_2_info_hin: '',
        sponsor_2_info_guj: '',
        stream_start_at: '',
        stream_end_at: '',
        original_sound: 1,
        enable_animation: 0,
        animation_urls: [],
    });

    const [waypoints, setWaypoints] = useState([]);
    const [saints, setSaints] = useState([]);
    const [deities, setDeities] = useState([]);
    const [journeys, setJourneys] = useState([]);
    const [projects, setProjects] = useState([]);
    const [audioArtifacts, setAudioArtifacts] = useState([]);
    const [artifactsFetched, setArtifactsFetched] = useState(false);
    const [searchArtifact, setSearchArtifact] = useState('');
    const [selectedAudioArtifacts, setSelectedAudioArtifacts] = useState([]);
    const [aartiConfig, setAartiConfig] = useState([]);

    const [selectedWaypoints, setSelectedWaypoints] = useState([]);
    const [selectedSaints, setSelectedSaints] = useState([]);
    const [selectedDeities, setSelectedDeities] = useState([]);
    const [selectedJourneys, setSelectedJourneys] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);

    const [searchWaypoint, setSearchWaypoint] = useState('');
    const [searchSaint, setSearchSaint] = useState('');
    const [searchDeity, setSearchDeity] = useState('');
    const [searchJourney, setSearchJourney] = useState('');
    const [searchProject, setSearchProject] = useState('');

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [charCount, setCharCount] = useState({
        stream_title: 0, stream_title_mar: 0, stream_title_hin: 0, stream_title_guj: 0
    });

    useEffect(() => {
        fetchWaypoints();
        fetchSaints();
        fetchDeities();
        fetchJourneys();
        fetchProjects();
    }, []);

    const fetchWaypoints = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/live-darshan/waypoints/list`);
            if (response.data.success === 1) setWaypoints(response.data.data);
        } catch (error) { console.error('Error fetching waypoints:', error); }
    };

    const fetchSaints = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/saints/list/1?limit=1000`);
            if (response.data.success === 1) setSaints(response.data.data);
        } catch (error) { console.error('Error fetching saints:', error); }
    };

    const fetchDeities = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/deity`);
            if (response.data.success === 1 || response.data.data) setDeities(response.data.data || []);
        } catch (error) { console.error('Error fetching deities:', error); }
    };

    const fetchJourneys = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/tripdetails`);
            if (response.data.data) setJourneys(response.data.data);
        } catch (error) { console.error('Error fetching journeys:', error); }
    };

    const fetchProjects = async () => {
        try {
            const response = await _axios.post(`${ServerPath}/projects/`, {
                page: 1, limit: 1000, searchText: '', project_types: [], regions: []
            });
            if (response.data.success === 1) setProjects(response.data.data);
        } catch (error) { console.error('Error fetching projects:', error); }
    };

    const fetchArtifacts = async () => {
        if (artifactsFetched) return;
        try {
            let page = 1, all = [];
            while (true) {
                const res = await _axios.get(`${ServerPath}/artifacts/page/?type=AUDIO_ORALS&page=${page}`);
                const data = res.data.data || [];
                all = [...all, ...data];
                if (data.length < 18) break;
                page++;
            }
            setAudioArtifacts(all);
        } catch (error) { console.error('Error fetching artifacts:', error); }
        setArtifactsFetched(true);
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (['stream_title', 'stream_title_mar', 'stream_title_hin', 'stream_title_guj'].includes(name)) {
            if (value.length > 50) {
                toast.error('Title cannot exceed 50 characters', { toastId: 'length-error' });
                return;
            }
            setCharCount(prev => ({ ...prev, [name]: value.length }));
        }
        if (name === 'stream_category') {
            setFormData(prev => ({
                ...prev,
                stream_category: value,
                ...(prev.stream_type !== 'youtube' ? { original_sound: value === 'live_darshan' ? 1 : 0 } : {}),
            }));
            return;
        }
        if (name === 'stream_start_at') {
            if (formData.stream_end_at && value >= formData.stream_end_at) {
                toast.error('Start time must be before end time');
                return;
            }
        }
        if (name === 'stream_end_at') {
            if (formData.stream_start_at && value <= formData.stream_start_at) {
                toast.error('End time must be after start time');
                return;
            }
        }
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleStreamTypeChange = (e) => {
        const newStreamType = e.target.value;
        setFormData(prev => ({
            ...prev,
            stream_type: newStreamType,
            youtube_video_id: newStreamType !== 'youtube' ? '' : prev.youtube_video_id,
            stream_key: newStreamType === 'youtube' ? '' : prev.stream_key,
            rtsp_url: '',
            hls_url: newStreamType !== 'cctv_external' ? '' : prev.hls_url,
            ...(newStreamType !== 'youtube' ? { original_sound: prev.stream_category === 'live_darshan' ? 1 : 0 } : {}),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || isSubmitted) return;

        try {
            setIsSubmitting(true);

            if (!formData.stream_type || !formData.stream_title || !formData.stream_title_guj || !formData.stream_title_hin || !formData.stream_title_mar) {
                toast.error('Please fill in all required fields');
                setIsSubmitting(false);
                return;
            }

            if (formData.stream_type === 'youtube' && !formData.youtube_video_id) {
                toast.error('YouTube video ID is required');
                setIsSubmitting(false);
                return;
            }

            if (formData.stream_type === 'cctv') {
                if (!formData.stream_key) {
                    toast.error('Stream key is required for CCTV streams');
                    setIsSubmitting(false);
                    return;
                }
                if (formData.stream_mode === 'rtsp_pull' && !formData.rtsp_url) {
                    toast.error('RTSP URL is required for RTSP Pull mode');
                    setIsSubmitting(false);
                    return;
                }
            }

            if (formData.stream_type === 'cctv_external' && !formData.hls_url) {
                toast.error('HLS URL is required for External CCTV streams');
                setIsSubmitting(false);
                return;
            }

            if (!formData.thumbnail_url) {
                toast.error('Thumbnail URL is required');
                setIsSubmitting(false);
                return;
            }

            if (!formData.stream_category) {
                toast.error('Stream category is required');
                setIsSubmitting(false);
                return;
            }

            if (formData.stream_start_at && formData.stream_end_at) {
                if (new Date(formData.stream_end_at) <= new Date(formData.stream_start_at)) {
                    toast.error('Stream end time must be after start time');
                    setIsSubmitting(false);
                    return;
                }
            }

            const isCctv = formData.stream_type === 'cctv' || formData.stream_type === 'cctv_external';
            const isAudioApplicable = isCctv;

            if (isCctv && formData.display_sponsor) {
                if (!formData.sponsor_1_name && !formData.sponsor_2_name) {
                    toast.error('At least one sponsor name (Sponsor 1 or Sponsor 2) is required');
                    setIsSubmitting(false);
                    return;
                }
            }

            if (isAudioApplicable) {
                if (formData.original_sound === 0 && selectedAudioArtifacts.length === 0) {
                    toast.error('At least one audio artifact is required when Original Sound is disabled');
                    setIsSubmitting(false);
                    return;
                }
                if (selectedAudioArtifacts.length > MAX_AUDIO_TRACKS) {
                    toast.error(`A playlist can contain at most ${MAX_AUDIO_TRACKS} audio tracks`);
                    setIsSubmitting(false);
                    return;
                }
            }

            const sponsorFields = (isCctv && formData.display_sponsor) ? {
                sponsor_1_name: formData.sponsor_1_name || null,
                sponsor_1_name_mar: formData.sponsor_1_name_mar || null,
                sponsor_1_name_hin: formData.sponsor_1_name_hin || null,
                sponsor_1_name_guj: formData.sponsor_1_name_guj || null,
                sponsor_1_image: formData.sponsor_1_image || null,       // ← add
                sponsor_1_info: formData.sponsor_1_info || null,         // ← add
                sponsor_1_info_mar: formData.sponsor_1_info_mar || null, // ← add
                sponsor_1_info_hin: formData.sponsor_1_info_hin || null, // ← add
                sponsor_1_info_guj: formData.sponsor_1_info_guj || null, // ← add
                sponsor_2_name: formData.sponsor_2_name || null,
                sponsor_2_name_mar: formData.sponsor_2_name_mar || null,
                sponsor_2_name_hin: formData.sponsor_2_name_hin || null,
                sponsor_2_name_guj: formData.sponsor_2_name_guj || null,
                sponsor_2_image: formData.sponsor_2_image || null,       // ← add
                sponsor_2_info: formData.sponsor_2_info || null,         // ← add
                sponsor_2_info_mar: formData.sponsor_2_info_mar || null, // ← add
                sponsor_2_info_hin: formData.sponsor_2_info_hin || null, // ← add
                sponsor_2_info_guj: formData.sponsor_2_info_guj || null, // ← add
            } : {};

            const cleanedAnimationUrls = (formData.animation_urls || []).map(u => u.trim()).filter(Boolean);
            if (isCctv && formData.enable_animation === 1) {
                if (cleanedAnimationUrls.length === 0) {
                    toast.error('Add at least one animation URL or disable Live Stream Animation');
                    setIsSubmitting(false);
                    return;
                }
                if (cleanedAnimationUrls.length > MAX_ANIMATIONS) {
                    toast.error(`Maximum ${MAX_ANIMATIONS} animation URLs allowed`);
                    setIsSubmitting(false);
                    return;
                }
            }

            const animationFields = isCctv ? {
                enable_animation: formData.enable_animation ? 1 : 0,
                animation_urls: formData.enable_animation && cleanedAnimationUrls.length ? cleanedAnimationUrls.join(',') : null,
            } : {};

            const audioFields = isAudioApplicable ? {
                original_sound: formData.original_sound,
                audio_artifact_ids: formData.original_sound === 0 ? selectedAudioArtifacts.map(a => a.artifact_id) : [],
            } : formData.stream_type === 'youtube' ? {
                original_sound: formData.original_sound,
            } : {};

            const payload = {
                stream_type: formData.stream_type,
                stream_category: formData.stream_category,
                stream_title: formData.stream_title,
                stream_title_mar: formData.stream_title_mar,
                stream_title_hin: formData.stream_title_hin,
                stream_title_guj: formData.stream_title_guj,
                youtube_video_id: formData.youtube_video_id || null,
                stream_key: formData.stream_key || null,
                rtsp_url: formData.rtsp_url || null,
                hls_url: formData.hls_url || null,
                thumbnail_url: formData.thumbnail_url,
                orientation: formData.orientation,
                is_featured: formData.is_featured ? 1 : 0,
                enable_multi_view: formData.enable_multi_view ? 1 : 0,
                auto_convert: formData.stream_type === 'cctv' ? formData.auto_convert : 0,
                stream_mode: formData.stream_type === 'cctv' ? formData.stream_mode : null,
                max_quality: formData.max_quality,
                display_sponsor: isCctv ? (formData.display_sponsor ? 1 : 0) : null,
                stream_start_at: toDbDatetime(formData.stream_start_at),
                stream_end_at: toDbDatetime(formData.stream_end_at),
                ...sponsorFields,
                ...animationFields,
                ...audioFields,
                waypoint_ids: selectedWaypoints.map(w => w.wpt_id),
                saint_ids: selectedSaints.map(s => s.id),
                deity_ids: selectedDeities.map(d => d.deity_id),
                journey_ids: selectedJourneys.map(j => j.journey_id),
                project_ids: selectedProjects.map(p => p.project_id),
                aarti_config: selectedWaypoints.length > 0 ? aartiConfig : [],
            };

            const response = await _axios.post(`${ServerPath}/live-darshan/create`, payload);

            if (response.data.success === 1) {
                const newStreamId = response.data.data?.id;
                if (formData.stream_type === 'youtube' && formData.stream_status !== 'draft' && newStreamId) {
                    await _axios.post(`${ServerPath}/live-darshan/update-status`, {
                        stream_id: newStreamId,
                        stream_status: formData.stream_status,
                    });
                }
                setIsSubmitted(true);
                toast.success('Stream added successfully');
                setTimeout(() => { onHide(); window.location.reload(); }, 1500);
            } else {
                toast.error(response.data.message || 'Failed to add stream');
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error('Error adding stream:', error);
            toast.error(error.response?.data?.message || 'Error adding stream');
            setIsSubmitting(false);
        }
    };

    const inputStyle = { height: '46px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF', borderRadius: '6px' };
    const labelStyle = { color: '#4A5568', fontWeight: '500', fontSize: '16px' };
    const isCctv = formData.stream_type === 'cctv' || formData.stream_type === 'cctv_external';
    const isAudioApplicable = isCctv;

    return (
        <Modal show={show} onHide={onHide} size='xl' centered style={{ borderRadius: '10px' }}>
            <div style={{ borderRadius: '10px' }}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0', padding: '20px 24px' }}>
                    <Modal.Title style={{ fontWeight: '600', fontSize: '22px' }}>Add New Live Stream</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: '24px' }}>
                    {/* <div style={{
                        background: '#F0F4FF',
                        border: '1px solid #C7D7FF',
                        borderRadius: '8px',
                        padding: '10px 16px',
                        marginBottom: '20px',
                        fontSize: '13px',
                        color: '#3730A3',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <span style={{ fontSize: '16px' }}>ℹ️</span>
                        Stream will be created in <strong>Draft</strong> status. Use "Go Live" from the table to make it visible to users.
                    </div> */}
                    <Form>
                        {/* Row 1: Stream Type | Stream Category | Orientation | Status (YouTube only) */}
                        <Row className='mb-3'>
                            <Col md={3}>
                                <Form.Group className='mb-3'>
                                    <Form.Label className='mb-2' style={labelStyle}>
                                        Stream Type <span className='text-danger'>*</span>
                                    </Form.Label>
                                    <Form.Select name='stream_type' value={formData.stream_type} onChange={handleStreamTypeChange} style={inputStyle}>
                                        <option value='youtube'>YouTube</option>
                                        <option value='cctv'>CCTV – Internal Server</option>
                                        <option value='cctv_external'>CCTV – External Server</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className='mb-3'>
                                    <Form.Label className='mb-2' style={labelStyle}>
                                        Stream Category <span className='text-danger'>*</span>
                                    </Form.Label>
                                    <Form.Select name='stream_category' value={formData.stream_category} onChange={handleInputChange} style={inputStyle}>
                                        {STREAM_CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className='mb-3'>
                                    <Form.Label className='mb-2' style={labelStyle}>
                                        Orientation <span className='text-danger'>*</span>
                                    </Form.Label>
                                    <Form.Select name='orientation' value={formData.orientation} onChange={handleInputChange} style={inputStyle}>
                                        <option value='portrait'>Portrait</option>
                                        <option value='landscape'>Landscape</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {formData.stream_type === 'youtube' && (
                                <Col md={3}>
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='mb-2' style={labelStyle}>Status</Form.Label>
                                        <Form.Select name='stream_status' value={formData.stream_status} onChange={handleInputChange} style={inputStyle}>
                                            <option value='draft'>Draft</option>
                                            <option value='live_now'>Live Now</option>
                                            <option value='recently_live'>Recently Live</option>
                                            <option value='archived'>Archived</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                        </Row>

                        {/* Row 2: Titles */}
                        <Row className='mb-3'>
                            {[
                                { name: 'stream_title', placeholder: 'English', label: 'Stream Title (English)' },
                                { name: 'stream_title_mar', placeholder: 'मराठी', label: 'Stream Title (Marathi)' },
                                { name: 'stream_title_hin', placeholder: 'हिन्दी', label: 'Stream Title (Hindi)' },
                                { name: 'stream_title_guj', placeholder: 'ગુજરાતી', label: 'Stream Title (Gujarati)' },
                            ].map(field => (
                                <Col md={3} key={field.name}>
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='mb-2' style={labelStyle}>
                                            {field.label} <span className='text-danger'>*</span>
                                        </Form.Label>
                                        <div className='position-relative'>
                                            <Form.Control type='text' name={field.name} value={formData[field.name]}
                                                onChange={handleInputChange} placeholder={field.placeholder}
                                                style={{ ...inputStyle, overflow: 'hidden', textOverflow: 'ellipsis' }} />
                                            <div style={{ position: 'absolute', bottom: '0px', right: '12px', fontSize: '11px', color: '#9CA3AF' }}>
                                                {charCount[field.name]}/50
                                            </div>
                                        </div>
                                    </Form.Group>
                                </Col>
                            ))}
                        </Row>



                        {/* YouTube fields */}
                        {formData.stream_type === 'youtube' && (
                            <>
                                <Row className='mb-3'>
                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='mb-2' style={labelStyle}>
                                                YouTube Video ID <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <Form.Control type='text' name='youtube_video_id' value={formData.youtube_video_id}
                                                onChange={handleInputChange} placeholder='e.g., dQw4w9WgXcQ' style={inputStyle} />
                                            <Form.Text className='text-muted'>
                                                (e.g., youtube.com/watch?v=<strong>dQw4w9WgXcQ</strong>)
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='mb-2' style={labelStyle}>
                                                Thumbnail URL <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <Form.Control type='text' name='thumbnail_url' value={formData.thumbnail_url}
                                                onChange={handleInputChange} placeholder='https://example.com/thumbnail.jpg' style={inputStyle} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Check type='checkbox' label='Featured Stream' name='is_featured'
                                            checked={formData.is_featured} onChange={handleInputChange} style={{ fontSize: '16px' }} />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Check type='checkbox' label='Enable Multi View' name='enable_multi_view'
                                            checked={formData.enable_multi_view} onChange={handleInputChange} style={{ fontSize: '16px' }}
                                            title='Allows this stream to be selected when creating a Multi View group.' />
                                    </Col>
                                </Row>
                                <FeaturedRow formData={formData} handleInputChange={handleInputChange} inputStyle={inputStyle} labelStyle={labelStyle} />
                                <Row className='mb-3'>
                                    <Col md={3} style={{ display: 'flex', alignItems: 'center' }}>
                                        <Form.Check type='checkbox' label='Original Sound'
                                            checked={formData.original_sound === 1}
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                original_sound: e.target.checked ? 1 : 0,
                                            }))}
                                            style={{ fontSize: '16px' }} />
                                    </Col>
                                </Row>
                                {formData.display_sponsor && (
                                    <SponsorFields formData={formData} handleInputChange={handleInputChange} inputStyle={inputStyle} labelStyle={labelStyle} />
                                )}
                                {isAudioApplicable && (
                                    <AudioSection formData={formData} setFormData={setFormData}
                                        audioArtifacts={audioArtifacts} searchArtifact={searchArtifact} setSearchArtifact={setSearchArtifact}
                                        artifactsFetched={artifactsFetched} onFetchArtifacts={fetchArtifacts}
                                        selectedAudioArtifacts={selectedAudioArtifacts} setSelectedAudioArtifacts={setSelectedAudioArtifacts} />
                                )}
                            </>
                        )}

                        {/* CCTV Internal fields */}
                        {formData.stream_type === 'cctv' && (
                            <>
                                <Row className='mb-3'>
                                    <Col md={12}>
                                        <Form.Label className='mb-2' style={labelStyle}>
                                            Stream Mode <span className='text-danger'>*</span>
                                        </Form.Label>
                                        <div className='d-flex gap-4'>
                                            {[
                                                { value: 'rtmp_push', title: 'RTMP Push', badge: '3–5s latency', badgeBg: '#E8F5E9', badgeColor: '#2E7D32', desc: 'NVR camera pushes stream to our server. Configure NVR with stream key.' },
                                                { value: 'rtsp_pull', title: 'RTSP Pull', badge: '15–30s latency', badgeBg: '#FFF3E0', badgeColor: '#E65100', desc: 'Our server pulls stream directly from camera RTSP URL.' },
                                            ].map(mode => (
                                                <div key={mode.value}
                                                    onClick={() => setFormData(prev => ({ ...prev, stream_mode: mode.value, rtsp_url: mode.value === 'rtmp_push' ? '' : prev.rtsp_url }))}
                                                    style={{
                                                        flex: 1, padding: '14px 18px', borderRadius: '10px', cursor: 'pointer',
                                                        border: `2px solid ${formData.stream_mode === mode.value ? '#5662F6' : '#E2E8F0'}`,
                                                        background: formData.stream_mode === mode.value ? '#F0F1FF' : '#FFFFFF',
                                                    }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
                                                        <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: `2px solid ${formData.stream_mode === mode.value ? '#5662F6' : '#CBD5E0'}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            {formData.stream_mode === mode.value && <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#5662F6' }} />}
                                                        </div>
                                                        <span style={{ fontWeight: '600', fontSize: '14px', color: formData.stream_mode === mode.value ? '#5662F6' : '#4A5568' }}>{mode.title}</span>
                                                        <span style={{ marginLeft: 'auto', fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '20px', background: mode.badgeBg, color: mode.badgeColor }}>{mode.badge}</span>
                                                    </div>
                                                    <div style={{ fontSize: '12px', color: '#718096', paddingLeft: '26px' }}>{mode.desc}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='mb-2' style={labelStyle}>
                                                Stream Key <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <Form.Control type='text' name='stream_key' value={formData.stream_key}
                                                onChange={handleInputChange} placeholder='e.g., somnath-darshan-1' style={inputStyle} />
                                            <Form.Text className='text-muted'>Use a unique identifier, e.g. somnath-darshan-1</Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='mb-2' style={labelStyle}>
                                                Thumbnail URL <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <Form.Control type='text' name='thumbnail_url' value={formData.thumbnail_url}
                                                onChange={handleInputChange} placeholder='https://example.com/thumbnail.jpg' style={inputStyle} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {formData.stream_mode === 'rtsp_pull' && (
                                    <Row className='mb-3'>
                                        <Col md={6}>
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='mb-2' style={labelStyle}>
                                                    RTSP URL <span className='text-danger'>*</span>
                                                </Form.Label>
                                                <Form.Control type='text' name='rtsp_url' value={formData.rtsp_url}
                                                    onChange={handleInputChange} placeholder='rtsp://user:pass@192.168.1.100:554/stream' style={inputStyle} />
                                                <Form.Text className='text-muted'>(eg: rtsp://user:pass@ip:port/path)</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}
                                <Row className='mb-3'>
                                    <Col md={12}>
                                        <div style={{
                                            padding: '14px 18px', borderRadius: '10px',
                                            border: '1px solid #E2E8F0', background: '#FAFAFA',
                                            display: 'flex', alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <div>
                                                <div style={{ fontWeight: '600', fontSize: '14px', color: '#4A5568', marginBottom: '3px' }}>
                                                    Auto Convert to Recording
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#718096' }}>
                                                    When enabled, the stream will be automatically saved as a recorded video when it ends.
                                                </div>
                                            </div>
                                            <Form.Check
                                                type='switch'
                                                id='auto_convert_switch'
                                                checked={formData.auto_convert === 1}
                                                onChange={(e) => setFormData(prev => ({
                                                    ...prev,
                                                    auto_convert: e.target.checked ? 1 : 0
                                                }))}
                                                style={{ fontSize: '16px' }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <FeaturedRow formData={formData} handleInputChange={handleInputChange} inputStyle={inputStyle} labelStyle={labelStyle} />
                                <AnimationSection formData={formData} setFormData={setFormData} inputStyle={inputStyle} labelStyle={labelStyle} />
                                {formData.display_sponsor && (
                                    <SponsorFields formData={formData} handleInputChange={handleInputChange} inputStyle={inputStyle} labelStyle={labelStyle} />
                                )}
                                {isAudioApplicable && (
                                    <AudioSection formData={formData} setFormData={setFormData}
                                        audioArtifacts={audioArtifacts} searchArtifact={searchArtifact} setSearchArtifact={setSearchArtifact}
                                        artifactsFetched={artifactsFetched} onFetchArtifacts={fetchArtifacts}
                                        selectedAudioArtifacts={selectedAudioArtifacts} setSelectedAudioArtifacts={setSelectedAudioArtifacts} />
                                )}
                            </>
                        )}

                        {/* CCTV External fields */}
                        {formData.stream_type === 'cctv_external' && (
                            <>
                                <Row className='mb-3'>
                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='mb-2' style={labelStyle}>
                                                HLS Stream URL <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <Form.Control type='text' name='hls_url' value={formData.hls_url}
                                                onChange={handleInputChange} placeholder='https://example.com/stream/playlist.m3u8' style={inputStyle} />
                                            <Form.Text className='text-muted'>Direct HLS URL from the external provider (ends in .m3u8)</Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='mb-2' style={labelStyle}>
                                                Thumbnail URL <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <Form.Control type='text' name='thumbnail_url' value={formData.thumbnail_url}
                                                onChange={handleInputChange} placeholder='https://example.com/thumbnail.jpg' style={inputStyle} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <FeaturedRow formData={formData} handleInputChange={handleInputChange} inputStyle={inputStyle} labelStyle={labelStyle} />
                                <AnimationSection formData={formData} setFormData={setFormData} inputStyle={inputStyle} labelStyle={labelStyle} />
                                {formData.display_sponsor && (
                                    <SponsorFields formData={formData} handleInputChange={handleInputChange} inputStyle={inputStyle} labelStyle={labelStyle} />
                                )}
                                {isAudioApplicable && (
                                    <AudioSection formData={formData} setFormData={setFormData}
                                        audioArtifacts={audioArtifacts} searchArtifact={searchArtifact} setSearchArtifact={setSearchArtifact}
                                        artifactsFetched={artifactsFetched} onFetchArtifacts={fetchArtifacts}
                                        selectedAudioArtifacts={selectedAudioArtifacts} setSelectedAudioArtifacts={setSelectedAudioArtifacts} />
                                )}
                            </>
                        )}

                        {/* Relations section */}
                        <hr style={{ margin: '8px 0 20px', borderColor: '#E2E8F0' }} />
                        <div style={{ marginBottom: '12px' }}>
                            <span style={{ fontWeight: '600', fontSize: '15px', color: '#4A5568' }}>Related Entities</span>
                            <span style={{ fontSize: '13px', color: '#A0AEC0', marginLeft: '8px' }}>(optional — link this stream to teerthas, saints, deities, parikramas or projects)</span>
                        </div>
                        <RelationPicker label='Related Temple/Teerthas'
                            searchValue={searchWaypoint} onSearchChange={setSearchWaypoint}
                            results={waypoints} idKey='wpt_id' nameKey='wpt_name'
                            selected={selectedWaypoints}
                            onSelect={w => setSelectedWaypoints(prev => [...prev, w])}
                            onRemove={id => setSelectedWaypoints(prev => prev.filter(w => w.wpt_id !== id))} />

                        {/* Scheduled Aarti playback — driven by the first tagged Temple/Teertha */}
                        <AartiSchedulePicker
                            wptId={selectedWaypoints[0]?.wpt_id || null}
                            audioArtifacts={audioArtifacts}
                            artifactsFetched={artifactsFetched}
                            onFetchArtifacts={fetchArtifacts}
                            value={aartiConfig}
                            onChange={setAartiConfig}
                        />

                        <RelationPicker label='Related Saints'
                            searchValue={searchSaint} onSearchChange={setSearchSaint}
                            results={saints} idKey='id' nameKey='name'
                            selected={selectedSaints}
                            onSelect={s => setSelectedSaints(prev => [...prev, s])}
                            onRemove={id => setSelectedSaints(prev => prev.filter(s => s.id !== id))} />
                        <RelationPicker label='Related Deities'
                            searchValue={searchDeity} onSearchChange={setSearchDeity}
                            results={deities} idKey='deity_id' nameKey='deity_name'
                            selected={selectedDeities}
                            onSelect={d => setSelectedDeities(prev => [...prev, d])}
                            onRemove={id => setSelectedDeities(prev => prev.filter(d => d.deity_id !== id))} />
                        <RelationPicker label='Related Parikramas'
                            searchValue={searchJourney} onSearchChange={setSearchJourney}
                            results={journeys} idKey='journey_id' nameKey='trip_name'
                            selected={selectedJourneys}
                            onSelect={j => setSelectedJourneys(prev => [...prev, j])}
                            onRemove={id => setSelectedJourneys(prev => prev.filter(j => j.journey_id !== id))} />
                        <RelationPicker label='Related Projects'
                            searchValue={searchProject} onSearchChange={setSearchProject}
                            results={projects} idKey='project_id' nameKey='project_title'
                            selected={selectedProjects}
                            onSelect={p => setSelectedProjects(prev => [...prev, p])}
                            onRemove={id => setSelectedProjects(prev => prev.filter(p => p.project_id !== id))} />
                    </Form>
                </Modal.Body>

                <div style={{ padding: '0 24px 24px 0', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant='secondary' onClick={onHide} className='me-2'
                        style={{ borderRadius: '6px', padding: '10px 24px', fontWeight: '500', fontSize: '16px' }}>
                        Cancel
                    </Button>
                    <Button variant='primary' onClick={handleSubmit} disabled={isSubmitting || isSubmitted}
                        style={{ backgroundColor: '#5662F6', borderColor: '#5662F6', borderRadius: '6px', padding: '10px 40px', fontWeight: '500', fontSize: '16px' }}>
                        {isSubmitting ? 'Adding...' : 'Add Stream'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CreateLiveStream;
